import { ChangeEvent, FC } from 'react';
import { Input } from '@chakra-ui/react';
import { FilterProps } from 'react-table';

const DefaultColumnFilter: FC<FilterProps<any>> = ({ column: { filterValue, setFilter } }) => {
    const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
        setFilter(e.target.value || undefined);
    };

    return <Input placeholder="Search..." size="sm" value={filterValue || ''} onChange={handleChange} />;
};

export default DefaultColumnFilter;
